import { h, Component } from 'preact';
import Game from './Game';

class App extends Component {
  render() {
    return <Game />;
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/